module.exports = __webpack_public_path__ + "static/img/sustainability_program_05.89ee1e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sustainability_program_05.jpg
// module id = j30D
// module chunks = 0